import { z } from "zod";

/** API'nin her hata yanıtında döndüğü gövde. `code` makine, `error` insan içindir. */
export const ApiErrorSchema = z.object({
  error: z.string(),
  code: z.string(),
  issues: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;
